import React, { Component } from 'react';
import request from 'request';

import DotPlot from '../components/dotplot.js';
import Scatterplot from '../components/scatterplot.js';
import Choropleth from '../components/choropleth.js';
import LineBarGraph from '../components/linebargraph.js';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.getAverage = this.getAverage.bind(this);
    this.getAverageResponse = this.getAverageResponse.bind(this);
    this.getCountryAverages = this.getCountryAverages.bind(this);
    this.getGeoData = this.getGeoData.bind(this);
    this.selectCountry = this.selectCountry.bind(this);
    this.state = {
      average_sat: [],
      average_q1: [],
      average_q2: [],
      average_q3: [],
      average_q4: [],
      country_averages: [],
      country_average_sat: [],
      country_average_q1: [],
      country_average_q2: [],
      country_average_q3: [],
      country_average_q4: [],
      geodata: {},
      data: {},
      country_data: {},
      selected: "World"
    }
  }

  componentDidMount() {
    this.getAverage();
    this.getAverageResponse();
    this.getGeoData();
    this.getCountryAverages();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.selected !== "World" && prevState.selected !== this.state.selected && this.state.country_averages !== undefined  && this.state.country_averages.length !== 0) {
      // Find selected element and then show data.
      let data = {};
      let found = false;
      for(let i = 0; i < this.state.country_averages.length; i++) {
        if (this.state.country_averages[i].country === this.state.selected) {
          data = this.state.country_averages[i];
          found = true;
        }
      }
      // Check if data is empty.
      if (found) {
        this.setState({
          country_average_sat: [
            (data.s1_1 + data.s2_1 + data.s3_1 + data.s4_1),
            (data.s1_2 + data.s2_2 + data.s3_2 + data.s4_2),
            (data.s1_3 + data.s2_3 + data.s3_3 + data.s4_3),
            (data.s1_4 + data.s2_4 + data.s3_4 + data.s4_4),
            (data.s1_5 + data.s2_5 + data.s3_5 + data.s4_5),
            (data.s1_6 + data.s2_6 + data.s3_6 + data.s4_6),
            (data.s1_7 + data.s2_7 + data.s3_7 + data.s4_7),
            (data.s1_8 + data.s2_8 + data.s3_8 + data.s4_8),
            (data.s1_9 + data.s2_9 + data.s3_9 + data.s4_9),
            (data.s1_10 + data.s2_10 + data.s3_10 + data.s4_10),
            (data.s1_11 + data.s2_11 + data.s3_11 + data.s4_11),
            (data.s1_12 + data.s2_12 + data.s3_12 + data.s4_12),
            (data.vision_s1 + data.vision_s2 + data.vision_s3 + data.vision_s4),
            (data.satisfied_s1 + data.satisfied_s2 + data.satisfied_s3 + data.satisfied_s4),
            (data.rules_s1 + data.rules_s2 + data.rules_s3 + data.rules_s4)
          ],
          country_average_q1: [data.q1_s1, data.q1_s2, data.q1_s3, data.q1_s4],
          country_average_q2: [data.q2_s1, data.q2_s2, data.q2_s3, data.q2_s4],
          country_average_q3: [data.q3_s1, data.q3_s2, data.q3_s3, data.q3_s4],
          country_average_q4: [data.q4_s1, data.q4_s2, data.q4_s3, data.q4_s4],
          country_data: data
        });
      } else {
        this.setState({
          country_average_sat: [],
          country_average_q1: [],
          country_average_q2: [],
          country_average_q3: [],
          country_average_q4: [],
          country_data: {}
        });
      }
    }
  }

  selectCountry(s) {
    this.setState({
      selected: s
    });
  }

  getAverage() {
    const parent = this;
    request("http://ahc-leadership-prd.oit.umn.edu/api/average_report", function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
                average_q1: [jsonBody['avg(q1_s1)'], jsonBody['avg(q1_s2)'], jsonBody['avg(q1_s3)'], jsonBody['avg(q1_s4)']], 
                average_q2: [jsonBody['avg(q2_s1)'], jsonBody['avg(q2_s2)'], jsonBody['avg(q2_s3)'], jsonBody['avg(q2_s4)']], 
                average_q3: [jsonBody['avg(q3_s1)'], jsonBody['avg(q3_s2)'], jsonBody['avg(q3_s3)'], jsonBody['avg(q3_s4)']], 
                average_q4: [jsonBody['avg(q4_s1)'], jsonBody['avg(q4_s2)'], jsonBody['avg(q4_s3)'], jsonBody['avg(q4_s4)']],
                data: {
                  q1_s1:jsonBody['avg(q1_s1)'],
                  q1_s2:jsonBody['avg(q1_s2)'],
                  q1_s3:jsonBody['avg(q1_s3)'],
                  q1_s4:jsonBody['avg(q1_s4)'],
                  q2_s1:jsonBody['avg(q2_s1)'],
                  q2_s2:jsonBody['avg(q2_s2)'],
                  q2_s3:jsonBody['avg(q2_s3)'],
                  q2_s4:jsonBody['avg(q2_s4)'],
                  q3_s1:jsonBody['avg(q3_s1)'],
                  q3_s2:jsonBody['avg(q3_s2)'],
                  q3_s3:jsonBody['avg(q3_s3)'],
                  q3_s4:jsonBody['avg(q3_s4)'], 
                  q4_s1:jsonBody['avg(q4_s1)'],
                  q4_s2:jsonBody['avg(q4_s2)'], 
                  q4_s3:jsonBody['avg(q4_s3)'], 
                  q4_s4:jsonBody['avg(q4_s4)']
                }
            });
        }
    });
  }

  getAverageResponse() {
    const parent = this;
    request("http://ahc-leadership-prd.oit.umn.edu/api/average_response", function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
              average_sat: [
                jsonBody['avg(s1_1)'] + jsonBody['avg(s2_1)'] + jsonBody['avg(s3_1)'] + jsonBody['avg(s4_1)'],
                jsonBody['avg(s1_2)'] + jsonBody['avg(s2_2)'] + jsonBody['avg(s3_2)'] + jsonBody['avg(s4_2)'],
                jsonBody['avg(s1_3)'] + jsonBody['avg(s2_3)'] + jsonBody['avg(s3_3)'] + jsonBody['avg(s4_3)'],
                jsonBody['avg(s1_4)'] + jsonBody['avg(s2_4)'] + jsonBody['avg(s3_4)'] + jsonBody['avg(s4_4)'],
                jsonBody['avg(s1_5)'] + jsonBody['avg(s2_5)'] + jsonBody['avg(s3_5)'] + jsonBody['avg(s4_5)'],
                jsonBody['avg(s1_6)'] + jsonBody['avg(s2_6)'] + jsonBody['avg(s3_6)'] + jsonBody['avg(s4_6)'],
                jsonBody['avg(s1_7)'] + jsonBody['avg(s2_7)'] + jsonBody['avg(s3_7)'] + jsonBody['avg(s4_7)'],
                jsonBody['avg(s1_8)'] + jsonBody['avg(s2_8)'] + jsonBody['avg(s3_8)'] + jsonBody['avg(s4_8)'],
                jsonBody['avg(s1_9)'] + jsonBody['avg(s2_9)'] + jsonBody['avg(s3_9)'] + jsonBody['avg(s4_9)'],
                jsonBody['avg(s1_10)'] + jsonBody['avg(s2_10)'] + jsonBody['avg(s3_10)'] + jsonBody['avg(s4_10)'],
                jsonBody['avg(s1_11)'] + jsonBody['avg(s2_11)'] + jsonBody['avg(s3_11)'] + jsonBody['avg(s4_11)'],
                jsonBody['avg(s1_12)'] + jsonBody['avg(s2_12)'] + jsonBody['avg(s3_12)'] + jsonBody['avg(s4_12)'],
                jsonBody['avg(vision_s1)'] + jsonBody['avg(vision_s2)'] + jsonBody['avg(vision_s3)'] + jsonBody['avg(vision_s4)'],
                jsonBody['avg(satisfied_s1)'] + jsonBody['avg(satisfied_s2)'] + jsonBody['avg(satisfied_s3)'] + jsonBody['avg(satisfied_s4)'],
                jsonBody['avg(empower_s1)'] + jsonBody['avg(empower_s2)'] + jsonBody['avg(empower_s3)'] + jsonBody['avg(empower_s4)'],
              ],
              count: jsonBody['COUNT(*)']
            });
        }
    });  
  }

  getGeoData() {
    const parent = this;
    const url = 'http://ahc-leadership-prd.oit.umn.edu/api/countries';
    request(url, function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
              geodata: jsonBody
            })
        }
    });
  }

  getCountryAverages() {
    const parent = this;
    const url = 'http://ahc-leadership-prd.oit.umn.edu/api/average_countries';
    request(url, function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
              country_averages: jsonBody,
            })
        }
    });
  }

  render() {
    let data = {};
    if (Object.keys(this.state.country_data).length !== 0 && this.state.country_data.constructor === Object) {
      data = this.state.country_data;
    } else {
      data = this.state.data;
    }
    return (
      <div className="Dashboard">
        <div className='row'>
          <div className='col-1'></div>
          <div className='col-10'>
            <h1 className='title center'> Minnesota Nursing Informatics Leadership Inventory™ Dashboard </h1>
            <div className='row'>
                <div className='col-12 card maroon'>
                  <h2 className='center'> Respondents By Country / Select A Country </h2>
                  <Choropleth name='choropleth' width='800' height='400' data={this.state.geodata} country_data={this.state.country_averages} selectCountry={this.selectCountry}></Choropleth>
                </div>
                <div className='col-6 card maroon'>
                    <h2 className='center'> Average Response of World </h2>
                    <Scatterplot name='scatterplot_world' width='450' height='400' data={this.state.data}></Scatterplot>
                </div>
                <div className='col-6 card maroon'>
                    <h2 className='center'> Average Response of {this.state.selected} </h2>
                    <Scatterplot name='scatterplot_country' width='450' height='400' data={data}></Scatterplot>
                  </div>
                <div className='col-12 card gold'>
                  <LineBarGraph name='q1' width='300' height='300' data={this.state.average_q1} userData={this.state.country_average_q1} group="Creative Culture"></LineBarGraph>
                </div>
                <div className='col-12 card gold'>
                  <LineBarGraph name='q2' width='300' height='300' data={this.state.average_q2} userData={this.state.country_average_q2}  group="Market Culture"></LineBarGraph>
                </div>
                <div className='col-12 card gold'>
                  <LineBarGraph name='q3' width='300' height='300' data={this.state.average_q3} userData={this.state.country_average_q3}  group="Hierarchy Culture"></LineBarGraph>
                </div>
                <div className='col-12 card gold'>
                  <LineBarGraph name='q4' width='300' height='300' data={this.state.average_q4} userData={this.state.country_average_q4}  group="Collaborative Culture"></LineBarGraph>
                </div>
                <div className='col-12 card maroon'>
                  <DotPlot name='DotPlot' legend="Local" width='800' height='300' data={this.state.average_sat} userData={this.state.country_average_sat}></DotPlot>
                </div>
            </div>

          </div>
          <div className='col-1'></div>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/dashboard.js